import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        ok: '&',
        cancel: '&'
    },
    template: `
    <div class="modal-header">
        <button type="button" class="close" ng-click="vm.cancel()"></button>
        <h2>{{ 'questionPool.Add question pool' | translate }}</h2>
    </div>
    <form ng-submit="vm.save()">
        <div class="modal-body">
            <div class="form">
                <forms-settings-pool-generaldata form="vm.form"></forms-settings-pool-generaldata>
            </div>
        </div>
        <div class="modal-footer" >
            <ul class="actions01">
                <li class="primary"><input type="submit" class="btn main" value="{{ 'general.Save' | translate }}"/></li>
                <li><button class="btn discrete" type="button" ng-click="vm.cancel()">{{ 'general.Cancel' | translate }}</button></li>
            </ul>
        </div>
    </form>
    `
})
export default class {
    constructor (FormFactory, QuestionPoolResource) {
        this.form = FormFactory.create(new QuestionPoolResource, model => model.$save());
    }

    save () {
        this.form.save()
            .then(() => {
                this.ok();
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/forms/settings/pool/add/index.js